<template lang="">
<div>
    
</div>
</template>

<script>

export default {
    name: 'SessionDetail',

    data() {
        return {
            meta: null,
        }
    },
    setup() {
    },

}
</script>

<style>
</style>
